import type { FC } from 'react'
import { List, ListSubheader, useTheme } from '@mui/material'

import { MenuItem, type MenuItemProps } from "../MenuItem/MenuItem"

export interface MenuSectionProps {
    title:string, 
    menuItems?: MenuItemProps[], 
    onItemClick?: React.MouseEventHandler<HTMLDivElement>
}

export const MenuSection: FC<MenuSectionProps> = ({
    title,
    menuItems, 
    onItemClick
}) => {

    const theme = useTheme()

    const items = menuItems?.map( (item, key) => {
        return(
            <MenuItem {...item} key={key} onClick={onItemClick}/>
        )
    })

    return (
        <List sx={{width: 360}} subheader={ 
            <ListSubheader sx={{ textTransform: 'uppercase', fontWeight: 600, backgroundColor:theme.palette.background.default}}>{title}</ListSubheader>
        }>
            {items}
        </List>
    )
}